import moment from 'moment';
/**
 * A class that can return the Office model
 */
export class Office {
  /** @param {Object} office FastJson object. */
  constructor(office = {}) {
    this.id = office.id || null;
    if (office.attributes) {
      this.name = office.attributes.name || null;
      this.timezone = office.attributes.timezone || null;
      this.weekends = office.attributes.weekends || [];
      this.fullTimeWorkingDay = office.attributes.full_time_working_day || null;
      this.businessHoursStart = office.attributes.business_hours_start ?
        moment.utc(office.attributes.business_hours_start).format('HH:mm') : null;
      this.businessHoursEnd = this.businessHoursStart && this.fullTimeWorkingDay ?
        moment(this.businessHoursStart, 'HH:mm').add(this.fullTimeWorkingDay, 'hours').format('HH:mm') :
        null;
      this.coreStart = office.attributes.core_start ?
        moment.utc(office.attributes.core_start).format('HH:mm') : null;
      this.coreEnd = office.attributes.core_end ?
        moment.utc(office.attributes.core_end).format('HH:mm') : null;
      this.loginMachineIds = office.attributes.login_machine_ids || [];
      this.logoutMachineIds = office.attributes.logout_machine_ids || [];
      this.googleCalendarId = office.attributes.google_calendar_id || null;
    } else {
      this.name = office.name || null;
      this.timezone = office.timezone || null;
      this.weekends = office.weekends || [];
      this.fullTimeWorkingDay = office.full_time_working_day || null;
      this.businessHoursStart = office.business_hours_start ?
        moment.utc(office.business_hours_start).format('HH:mm') : null;
      this.businessHoursEnd = this.businessHoursStart && this.fullTimeWorkingDay ?
        moment(this.businessHoursStart, 'HH:mm').add(this.fullTimeWorkingDay, 'hours').format('HH:mm') :
        null;
      this.coreStart = office.core_start ?
        moment.utc(office.core_start).format('HH:mm') : null;
      this.coreEnd = office.core_end ?
        moment.utc(office.core_end).format('HH:mm') : null;
      this.loginMachinesIds = office.login_machines_ids || [];
      this.logoutMachinesIds = office.logout_machines_ids || [];
      this.googleCalendarId = office.google_calendar_id || null;
    }
  }
}
